import React from 'react';
import { VolumeSection } from './VolumeSection';
import { volumes } from '../data/kit';
export function VolumesList() {
  return <section className="w-full bg-surface" aria-label="Los 3 volúmenes del kit" data-id="element-369" data-mp="201eviu7jk95y">
      <div className="mx-auto max-w-6xl px-5" data-id="element-370" data-mp="1m145fte22ylu">
        {volumes.map((volume, i) => <VolumeSection key={volume.id} volume={volume} reversed={i % 2 === 1} data-id="element-371" data-mp="1r0h030b659yz" data-mpi={i} />)}
      </div>
    </section>;
}